// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1b10I","topBottomGutter":"Layout_topBottomGutter__2OXsy"};